import React from 'react';
import { Typography } from '@material-ui/core';
import useStyles from './styles';

export default (props) => {
  const { primary, secondary, hideSmallPrimary, ...rest } = props;
  const classes = useStyles();
  return (
    <Typography component={'div'} variant={'body2'} {...rest}>
      <span className={hideSmallPrimary && classes.hideSmall} style={{ fontWeight: 'bold' }}>
        {primary}
      </span>
      {secondary && <>{secondary}</>}
    </Typography>
  );
};
